export const FEE = {
  DEFAULT: 100,
  MINIMUM: 10,
  MAXIMUM: 99999990,
} as const

export const PAYMENT_CURRENCY = {
  TWD: 2,
  USD: 1,
} as const

export const PAYMENT_TYPE = {
  GLOWS_PLATFORM_BALANCE: -1,
  STRIPE: 3,
  PAYPAL: 6,
  NEWEBPAY: 7,
} as const

export const INVOICE_TYPES = [
  { value: 'electronic', label: 'Electronic invoice (Duplicate)' },
  { value: 'mobile-barcode', label: 'Personal - Mobile Barcode Carrier' },
  { value: 'unified-business', label: 'Company - Unified Business Number' },
  { value: 'donation', label: 'Invoice Donation' },
] as const

export const DEBOUNCE_DELAYS = {
  AUTO_CORRECT: 800,
  PAYMENT_AMOUNT: 300,
} as const

export const FORM_VALIDATION = {
  EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  MOBILE_BARCODE_REGEX: /^\/[0-9A-Z+\-.]{7}$/,
} as const

export const FIELD_LENGTHS = {
  NAME_MAX: 30,
  BUSINESS_NAME_MAX: 60,
} as const

export const BILL_CATALOG = {
  ALL: 0,
  INSTANCES: 1,
  OTHERS: 2,
} as const
